//     This code was generated by a Reinforced.Typings tool.
//     Changes to this file may cause incorrect behavior and will be lost if
//     the code is regenerated.

export enum ActionableInsightCategory {
  UserActionableInsights = 'UserActionableInsights',
  RuntimeOptimization = 'RuntimeOptimization',
  SystemExceptions = 'SystemExceptions',
  BusinessExceptions = 'BusinessExceptions'
}
export const ActionableInsightCategoryDescription = new Map<string, string>([
  [ActionableInsightCategory.UserActionableInsights, 'Analyst\'s insights'],
  [ActionableInsightCategory.RuntimeOptimization, 'Runtime optimization'],
  [ActionableInsightCategory.SystemExceptions, 'System exceptions'],
  [ActionableInsightCategory.BusinessExceptions, 'Business exceptions'],
]);

export enum ActionableInsightStatus {
  Starred = 'Starred',
  Resolved = 'Resolved',
  Irrelevant = 'Irrelevant'
}
export enum ActionableInsightType {
  Exception = 'Exception',
  ExceptionBluePrism = 'ExceptionBluePrism',
  Outliers = 'Outliers',
  ForcedStop = 'ForcedStop',
  WaitOptimization = 'WaitOptimization',
  UnnecessaryInitializations = 'UnnecessaryInitializations',
  IdleRuns = 'IdleRuns',
  ItemDurationTrend = 'ItemDurationTrend',
  InterruptedJobs = 'InterruptedJobs',
  RpaObject = 'RpaObject',
  Rework = 'Rework',
  User = 'User',
  Other = 'Other'
}
export enum AiProviderType {
  AzureAIInference = 'AzureAIInference',
  AzureOpenAI = 'AzureOpenAI',
  OpenAI = 'OpenAI',
  Google = 'Google',
  HuggingFace = 'HuggingFace',
  Ollama = 'Ollama',
  Anthropic = 'Anthropic',
  AmazonBedrock = 'AmazonBedrock'
}
export enum AlertConditionType {
  Lower = 'Lower',
  Equal = 'Equal',
  Greater = 'Greater'
}
export enum AlertRuleType {
  Metric = 'Metric',
  ProcessNotStarted = 'ProcessNotStarted',
  ProcessFailed = 'ProcessFailed',
  ProcessOrResourceQuarantined = 'ProcessOrResourceQuarantined',
  ResourceRestarted = 'ResourceRestarted',
  ResourceLoginLogout = 'ResourceLoginLogout',
  MaintenanceWindow = 'MaintenanceWindow',
  IncidentDetected = 'IncidentDetected'
}
export enum AlertTargetType {
  InApp = 'InApp',
  Email = 'Email',
  MsTeams = 'MsTeams'
}
export enum CalendarEventType {
  MaintenanceWindow = 'MaintenanceWindow',
  Event = 'Event',
  Holiday = 'Holiday'
}
export enum CalendarRecurrenceType {
  Daily = 'Daily',
  Weekly = 'Weekly',
  Weekday = 'Weekday',
  Monthly = 'Monthly',
  EveryLastWeekDayOfMonth = 'EveryLastWeekDayOfMonth',
  WeekDayInMonth = 'WeekDayInMonth',
  Yearly = 'Yearly'
}
export enum EvaluationRunStatus {
  Pending = 'Pending',
  Running = 'Running',
  Completed = 'Completed',
  Failed = 'Failed'
}
export enum EvaluationType {
  Manual = 'Manual',
  LLMAsJudge = 'LLMAsJudge',
  ExactMatch = 'ExactMatch'
}
export enum EventTraceType {
  StartSession = 'StartSession',
  StartSessionFailed = 'StartSessionFailed',
  CancelStartSession = 'CancelStartSession',
  SessionEnded = 'SessionEnded',
  SessionEndedFailed = 'SessionEndedFailed',
  RequestStopSession = 'RequestStopSession',
  RequestStopSessionFailed = 'RequestStopSessionFailed',
  ManualRequestStopSession = 'ManualRequestStopSession',
  ManualRequestStopSessionFailed = 'ManualRequestStopSessionFailed',
  LoginResource = 'LoginResource',
  LoginResourceFailed = 'LoginResourceFailed',
  LogoutResource = 'LogoutResource',
  LogoutResourceFailed = 'LogoutResourceFailed',
  RestartResource = 'RestartResource',
  RestartResourceFailed = 'RestartResourceFailed',
  RestartResourceEnd = 'RestartResourceEnd',
  ManualRestartResource = 'ManualRestartResource',
  ManualRestartResourceFailed = 'ManualRestartResourceFailed',
  TurnOnResource = 'TurnOnResource',
  TurnOnResourceFailed = 'TurnOnResourceFailed',
  TurnOnResourceEnd = 'TurnOnResourceEnd',
  TurnOffResource = 'TurnOffResource',
  TurnOffResourceFailed = 'TurnOffResourceFailed',
  TurnOffResourceEnd = 'TurnOffResourceEnd',
  ManualTurnOnResource = 'ManualTurnOnResource',
  ManualTurnOnResourceFailed = 'ManualTurnOnResourceFailed',
  ManualTurnOffResource = 'ManualTurnOffResource',
  ManualTurnOffResourceFailed = 'ManualTurnOffResourceFailed',
  DeletePendingSession = 'DeletePendingSession',
  DeletePendingSessionFailed = 'DeletePendingSessionFailed',
  Nothing = 'Nothing',
  StartShell = 'StartShell',
  StartShellFailed = 'StartShellFailed',
  SetTasksIsActive = 'SetTasksIsActive',
  SetProcessIsQuarantined = 'SetProcessIsQuarantined',
  SetProcessIsNotQuarantined = 'SetProcessIsNotQuarantined',
  SetResourceIsQuarantined = 'SetResourceIsQuarantined',
  SetResourceIsNotQuarantined = 'SetResourceIsNotQuarantined',
  SetExternalSystemIsQuarantined = 'SetExternalSystemIsQuarantined',
  SetExternalSystemIsNotQuarantined = 'SetExternalSystemIsNotQuarantined',
  SetLoginUserIsQuarantined = 'SetLoginUserIsQuarantined',
  SetLoginUserIsNotQuarantined = 'SetLoginUserIsNotQuarantined',
  ManualSetProcessIsQuarantined = 'ManualSetProcessIsQuarantined',
  ManualSetProcessIsNotQuarantined = 'ManualSetProcessIsNotQuarantined',
  ManualSetResourceIsQuarantined = 'ManualSetResourceIsQuarantined',
  ManualSetResourceIsNotQuarantined = 'ManualSetResourceIsNotQuarantined',
  ManualSetExternalSystemIsQuarantined = 'ManualSetExternalSystemIsQuarantined',
  ManualSetExternalSystemIsNotQuarantined = 'ManualSetExternalSystemIsNotQuarantined',
  ManualSetLoginUserIsQuarantined = 'ManualSetLoginUserIsQuarantined',
  ManualSetLoginUserIsNotQuarantined = 'ManualSetLoginUserIsNotQuarantined',
  EnableLicenseRuntime = 'EnableLicenseRuntime',
  EnableLicenseRuntimeFailed = 'EnableLicenseRuntimeFailed',
  DisableLicenseRuntime = 'DisableLicenseRuntime',
  DisableLicenseRuntimeFailed = 'DisableLicenseRuntimeFailed',
  ConditionStateChanged = 'ConditionStateChanged',
  ConditionEvaluationFailed = 'ConditionEvaluationFailed',
  MaintenanceWindow = 'MaintenanceWindow'
}
export enum FeatureFlags {
  BenchmarkingFormulas = 'BenchmarkingFormulas',
  DumpViewer = 'DumpViewer',
  UseDemoIncidents = 'UseDemoIncidents',
  AdditionalFieldsForProcessGroup = 'AdditionalFieldsForProcessGroup',
  Workflows = 'Workflows',
  MsTeamsIntegration = 'MsTeamsIntegration'
}
export enum HttpMethodType {
  GET = 'GET',
  POST = 'POST',
  PUT = 'PUT',
  DELETE = 'DELETE',
  PATCH = 'PATCH',
  HEAD = 'HEAD'
}
export enum ImpactCategory {
  Low = 'Low',
  Medium = 'Medium',
  High = 'High'
}
export enum ImpactMultipliedBy {
  NotMultiplied = 'NotMultiplied',
  RobotHour = 'RobotHour',
  ItemManualProcessing = 'ItemManualProcessing'
}
export enum IncidentCategory {
  Alert = 'Alert',
  Anomaly = 'Anomaly',
  Forecasting = 'Forecasting',
  NegativeTrend = 'NegativeTrend'
}
export enum IncidentEventType {
  CopyLink = 'CopyLink',
  ThumbUp = 'ThumbUp',
  ThumbDown = 'ThumbDown',
  OpenDashboard = 'OpenDashboard'
}
export enum IncidentFeedback {
  None = 'None',
  Positive = 'Positive',
  Negative = 'Negative'
}
export enum MetricRuleTimeInterval {
  Last5Minutes = 'Last5Minutes',
  Last15Minutes = 'Last15Minutes',
  LastHour = 'LastHour',
  Last4Hours = 'Last4Hours',
  Last12Hours = 'Last12Hours',
  LastDay = 'LastDay'
}
export enum MonitoringMetricFrequency {
  Minutes5 = 'Minutes5',
  Minutes15 = 'Minutes15',
  Hourly = 'Hourly',
  Daily = 'Daily'
}
export enum MonitoringMetricType {
  ItemCount = 'ItemCount',
  ItemSystemExceptionCount = 'ItemSystemExceptionCount',
  ItemBusinessExceptionCount = 'ItemBusinessExceptionCount',
  ItemCompletedCount = 'ItemCompletedCount',
  ItemBusinessExceptionRate = 'ItemBusinessExceptionRate',
  ItemSuccessRate = 'ItemSuccessRate',
  ItemAverageDuration = 'ItemAverageDuration',
  ItemSuccessAverageDuration = 'ItemSuccessAverageDuration',
  ItemCompletedAverageDuration = 'ItemCompletedAverageDuration',
  ItemSystemExceptionAverageDuration = 'ItemSystemExceptionAverageDuration',
  ItemBusinessExceptionAverageDuration = 'ItemBusinessExceptionAverageDuration',
  ItemNotStartedCount = 'ItemNotStartedCount',
  ItemPendingCount = 'ItemPendingCount',
  ItemViolatedSlaCount = 'ItemViolatedSlaCount',
  ItemPendingMaxTime = 'ItemPendingMaxTime',
  ItemPendingAverageTime = 'ItemPendingAverageTime',
  ItemFteExpectedSavings = 'ItemFteExpectedSavings',
  ItemManualProcessingTimeInMinutesSavings = 'ItemManualProcessingTimeInMinutesSavings',
  SessionLoggingRate = 'SessionLoggingRate',
  SessionLogsSize = 'SessionLogsSize',
  SessionCount = 'SessionCount',
  SessionSystemExceptionCount = 'SessionSystemExceptionCount',
  SessionBusinessExceptionCount = 'SessionBusinessExceptionCount',
  SessionCompletedCount = 'SessionCompletedCount',
  SessionSuccessRate = 'SessionSuccessRate',
  SessionAverageDuration = 'SessionAverageDuration',
  SessionCompletedAverageDuration = 'SessionCompletedAverageDuration',
  SessionSuccessAverageDuration = 'SessionSuccessAverageDuration',
  SessionSystemExceptionAverageDuration = 'SessionSystemExceptionAverageDuration',
  SessionBusinessExceptionAverageDuration = 'SessionBusinessExceptionAverageDuration',
  SessionResourceUtilization = 'SessionResourceUtilization',
  SessionLicenseUtilization = 'SessionLicenseUtilization',
  ProcessCount = 'ProcessCount',
  ResourceCount = 'ResourceCount',
  LicenseCount = 'LicenseCount',
  ProcessCreatedCount = 'ProcessCreatedCount',
  ProcessUpdatedCount = 'ProcessUpdatedCount'
}
export const MonitoringMetricTypeDescription = new Map<string, string>([
  [MonitoringMetricType.ItemCount, 'Item count'],
  [MonitoringMetricType.ItemSystemExceptionCount, 'Item system exceptions'],
  [MonitoringMetricType.ItemBusinessExceptionCount, 'Item business exceptions'],
  [MonitoringMetricType.ItemCompletedCount, 'Item completed'],
  [MonitoringMetricType.ItemBusinessExceptionRate, 'Item business exception rate'],
  [MonitoringMetricType.ItemSuccessRate, 'Item success rate'],
  [MonitoringMetricType.ItemAverageDuration, 'Item average duration'],
  [MonitoringMetricType.ItemSuccessAverageDuration, 'Item success average duration'],
  [MonitoringMetricType.ItemCompletedAverageDuration, 'Item completed average duration'],
  [MonitoringMetricType.ItemSystemExceptionAverageDuration, 'Item system exceptions average duration'],
  [MonitoringMetricType.ItemBusinessExceptionAverageDuration, 'Item business exceptions average duration'],
  [MonitoringMetricType.ItemNotStartedCount, 'Item not started'],
  [MonitoringMetricType.ItemPendingCount, 'Item pendings'],
  [MonitoringMetricType.ItemViolatedSlaCount, 'Item violated SLA'],
  [MonitoringMetricType.ItemPendingMaxTime, 'Item pending max'],
  [MonitoringMetricType.ItemPendingAverageTime, 'Item pending avg'],
  [MonitoringMetricType.ItemFteExpectedSavings, 'Item FTE savings'],
  [MonitoringMetricType.ItemManualProcessingTimeInMinutesSavings, 'Item manual processing time savings'],
  [MonitoringMetricType.SessionLoggingRate, 'Process run logging rate'],
  [MonitoringMetricType.SessionLogsSize, 'Process run logs size'],
  [MonitoringMetricType.SessionCount, 'Process run count'],
  [MonitoringMetricType.SessionSystemExceptionCount, 'Process run system exceptions'],
  [MonitoringMetricType.SessionBusinessExceptionCount, 'Process run business exceptions'],
  [MonitoringMetricType.SessionCompletedCount, 'Process run completed count'],
  [MonitoringMetricType.SessionSuccessRate, 'Process run success rate'],
  [MonitoringMetricType.SessionAverageDuration, 'Process run average duration'],
  [MonitoringMetricType.SessionCompletedAverageDuration, 'Process run completed average duration'],
  [MonitoringMetricType.SessionSuccessAverageDuration, 'Process run success average duration'],
  [MonitoringMetricType.SessionSystemExceptionAverageDuration, 'Process run system exceptions average duration'],
  [MonitoringMetricType.SessionBusinessExceptionAverageDuration, 'Process run business exceptions average duration'],
  [MonitoringMetricType.SessionResourceUtilization, 'Process run machine utilization'],
  [MonitoringMetricType.SessionLicenseUtilization, 'Process run license utilization'],
  [MonitoringMetricType.ProcessCount, 'Process count'],
  [MonitoringMetricType.ResourceCount, 'Machine count'],
  [MonitoringMetricType.LicenseCount, 'License count'],
  [MonitoringMetricType.ProcessCreatedCount, 'Newly created processes'],
  [MonitoringMetricType.ProcessUpdatedCount, 'Updated processes'],
]);

export enum MonitoringResourceStatus {
  Working = 'Working',
  Pending = 'Pending',
  Available = 'Available',
  NotResponding = 'NotResponding',
  Offline = 'Offline',
  LoggedOut = 'LoggedOut',
  Private = 'Private',
  NoLicenses = 'NoLicenses'
}
export enum MonitoringResourceType {
  Default = 'Default',
  Serverless = 'Serverless',
  ElasticPool = 'ElasticPool'
}
export enum NotificationType {
  ProcessNotStarted = 'ProcessNotStarted',
  ProcessFailed = 'ProcessFailed',
  ProcessQuarantined = 'ProcessQuarantined',
  ResourceRestarted = 'ResourceRestarted',
  ResourceLoginFailed = 'ResourceLoginFailed',
  ResourceLogoutFailed = 'ResourceLogoutFailed',
  ResourceQuarantined = 'ResourceQuarantined',
  LoginUserQuarantined = 'LoginUserQuarantined',
  ExternalSystemQuarantined = 'ExternalSystemQuarantined',
  MaintenanceWindowStarted = 'MaintenanceWindowStarted',
  MaintenanceWindowEnded = 'MaintenanceWindowEnded',
  Custom = 'Custom'
}
export enum Role {
  OrganizationAdministrator = 'OrganizationAdministrator',
  AutomationTeam = 'AutomationTeam',
  ProcessOwner = 'ProcessOwner'
}
export const RoleDescription = new Map<string, string>([
  [Role.OrganizationAdministrator, 'Organization admin'],
  [Role.AutomationTeam, 'Automation team'],
  [Role.ProcessOwner, 'Process owner'],
]);

export enum SchedulerConditionStateType {
  File = 'File',
  Directory = 'Directory',
  Webhook = 'Webhook',
  DateTime = 'DateTime',
  Time = 'Time',
  RunNow = 'RunNow',
  Email = 'Email',
  SharePoint = 'SharePoint',
  SharePointList = 'SharePointList',
  CancelNow = 'CancelNow',
  ProcessFinished = 'ProcessFinished',
  TaskFinished = 'TaskFinished',
  Exception = 'Exception',
  OnceAPeriod = 'OnceAPeriod',
  FrozenSession = 'FrozenSession',
  LongItem = 'LongItem',
  LongSession = 'LongSession',
  LongSessionWithItems = 'LongSessionWithItems'
}
export enum SessionStatus {
  Pending = 'Pending',
  Running = 'Running',
  Terminated = 'Terminated',
  Stopped = 'Stopped',
  Completed = 'Completed',
  Debugging = 'Debugging',
  Archived = 'Archived',
  Stopping = 'Stopping',
  Warning = 'Warning',
  Terminating = 'Terminating',
  Suspended = 'Suspended',
  Resumed = 'Resumed',
  NotResponding = 'NotResponding',
  VirtualPending = 'VirtualPending',
  VirtualCanceling = 'VirtualCanceling',
  VirtualLoggingIn = 'VirtualLoggingIn'
}
export const SessionStatusDescription = new Map<string, string>([
  [SessionStatus.Pending, 'Pending'],
  [SessionStatus.Running, 'Running'],
  [SessionStatus.Terminated, 'Terminated'],
  [SessionStatus.Stopped, 'Stopped'],
  [SessionStatus.Completed, 'Successful'],
  [SessionStatus.Debugging, 'Debugging'],
  [SessionStatus.Archived, 'Archived or deleted'],
  [SessionStatus.Stopping, 'Stopping'],
  [SessionStatus.Warning, 'Warning'],
  [SessionStatus.Terminating, 'Terminating'],
  [SessionStatus.Suspended, 'Suspended'],
  [SessionStatus.Resumed, 'Resumed'],
  [SessionStatus.NotResponding, 'Not responding'],
  [SessionStatus.VirtualPending, 'Pending'],
  [SessionStatus.VirtualCanceling, 'Canceling...'],
  [SessionStatus.VirtualLoggingIn, 'Logging in'],
]);

export enum WorkflowFormFieldDirection {
  Input = 'Input',
  Output = 'Output',
  InputOutput = 'InputOutput'
}
export enum WorkflowFormFieldType {
  StaticText = 'StaticText',
  Text = 'Text',
  MultiLineText = 'MultiLineText'
}
export enum WorkflowRunStatus {
  Pending = 'Pending',
  Running = 'Running',
  Succeeded = 'Succeeded',
  Failed = 'Failed'
}
export enum WorkflowWorkItemState {
  New = 'New',
  InProgress = 'InProgress',
  Done = 'Done'
}
export enum AlertSeverity {
  Info = 'Info',
  Warning = 'Warning',
  Error = 'Error'
}
export enum ChangeType {
  Create = 'Create',
  Update = 'Update',
  Delete = 'Delete'
}
export enum ExceptionSource {
  Tag = 'Tag',
  Message = 'Message'
}
export enum ExceptionType {
  BusinessException = 'BusinessException',
  SystemException = 'SystemException',
  UnexpectedInterruption = 'UnexpectedInterruption'
}
export enum LicensesCountMode {
  All = 'All',
  AllExcept = 'AllExcept',
  ExplicitCount = 'ExplicitCount'
}
export enum ManagementMetricType {
  SavingsMoney = 'SavingsMoney',
  SavingsHoursBackToBusiness = 'SavingsHoursBackToBusiness',
  SavingsFte = 'SavingsFte',
  ExpectedSavingsHours = 'ExpectedSavingsHours',
  ExpectedSavingsFte = 'ExpectedSavingsFte',
  TasksProcessed = 'TasksProcessed',
  NumberOfProcesses = 'NumberOfProcesses',
  TasksAverageSuccessRate = 'TasksAverageSuccessRate',
  MostExpensiveProcesses = 'MostExpensiveProcesses',
  RobotHours = 'RobotHours',
  SystemExceptionCosts = 'SystemExceptionCosts',
  BusinessExceptionCosts = 'BusinessExceptionCosts',
  TopExceptions = 'TopExceptions',
  LicenseUtilization = 'LicenseUtilization'
}
export const ManagementMetricTypeDescription = new Map<string, string>([
  [ManagementMetricType.SavingsMoney, 'Monetary savings'],
  [ManagementMetricType.SavingsHoursBackToBusiness, 'Hours back to business'],
  [ManagementMetricType.SavingsFte, 'Saved workload (FTE)'],
  [ManagementMetricType.ExpectedSavingsHours, 'Originally expected savings (hours)'],
  [ManagementMetricType.ExpectedSavingsFte, 'Originally expected savings (FTE)'],
  [ManagementMetricType.TasksProcessed, 'Tasks processed'],
  [ManagementMetricType.NumberOfProcesses, 'Number of processes ran'],
  [ManagementMetricType.TasksAverageSuccessRate, 'Success rate'],
  [ManagementMetricType.MostExpensiveProcesses, 'Processes generating the greatest savings'],
  [ManagementMetricType.RobotHours, 'Robot-hours spent'],
  [ManagementMetricType.SystemExceptionCosts, 'Total cost of system exceptions'],
  [ManagementMetricType.BusinessExceptionCosts, 'Total cost of business exceptions'],
  [ManagementMetricType.TopExceptions, 'Costly exceptions'],
  [ManagementMetricType.LicenseUtilization, 'License utilization'],
]);

export enum Platform {
  BluePrism = 'BluePrism',
  BluePrismNextGen = 'BluePrismNextGen',
  UiPath = 'UiPath',
  AutomationAnywhere = 'AutomationAnywhere',
  PowerAutomateDesktop = 'PowerAutomateDesktop',
  PowerAutomateCloud = 'PowerAutomateCloud'
}
export const PlatformDescription = new Map<string, string>([
  [Platform.BluePrism, 'Blue Prism'],
  [Platform.BluePrismNextGen, 'Blue Prism Next Gen'],
  [Platform.UiPath, 'UiPath'],
  [Platform.AutomationAnywhere, 'Automation Anywhere'],
  [Platform.PowerAutomateDesktop, 'Power Automate (Desktop)'],
  [Platform.PowerAutomateCloud, 'Power Automate (Cloud)'],
]);

export enum SavingsUnit {
  FTE = 'FTE',
  Hours = 'Hours'
}
export enum TenantSynchronizationMode {
  None = 'None',
  Synchronization = 'Synchronization',
  SynchronizationAndOrchestration = 'SynchronizationAndOrchestration'
}
export enum UiPathRuntimeType {
  Unattended = 'Unattended',
  NonProduction = 'NonProduction',
  TestAutomation = 'TestAutomation'
}
export const UiPathRuntimeTypeDescription = new Map<string, string>([
  [UiPathRuntimeType.Unattended, 'Unattended'],
  [UiPathRuntimeType.NonProduction, 'Non-production'],
  [UiPathRuntimeType.TestAutomation, 'Testing'],
]);

export enum ApiPermission {
  AlertRules = 'AlertRules',
  Anomalies = 'Anomalies',
  ApiCredentials = 'ApiCredentials',
  AuditLog = 'AuditLog',
  BenchmarkMetrics = 'BenchmarkMetrics',
  BillingGroupsWrite = 'BillingGroupsWrite',
  Calendar = 'Calendar',
  DomainsWrite = 'DomainsWrite',
  ExternalApi = 'ExternalApi',
  ExternalSystemsWrite = 'ExternalSystemsWrite',
  Import = 'Import',
  Incidents = 'Incidents',
  LogProcessing = 'LogProcessing',
  Logs = 'Logs',
  Marketplace = 'Marketplace',
  MonitoringConfiguration = 'MonitoringConfiguration',
  GeneralSettings = 'GeneralSettings',
  UsersSettings = 'UsersSettings',
  AnomaliesSettings = 'AnomaliesSettings',
  ExternalServicesSettings = 'ExternalServicesSettings',
  PendingSessions = 'PendingSessions',
  OrchestrationDebugging = 'OrchestrationDebugging',
  ReportingSettings = 'ReportingSettings',
  SavingsSettings = 'SavingsSettings',
  BenchmarkingSettings = 'BenchmarkingSettings',
  ImportExportSettings = 'ImportExportSettings',
  ProcessesWrite = 'ProcessesWrite',
  ProcessGroupsWrite = 'ProcessGroupsWrite',
  ProcessGroupsVisibilityWrite = 'ProcessGroupsVisibilityWrite',
  Reporting = 'Reporting',
  ResourceGroupsWrite = 'ResourceGroupsWrite',
  ResourcesWrite = 'ResourcesWrite',
  RpaSystem = 'RpaSystem',
  SchedulerConditionStates = 'SchedulerConditionStates',
  SchedulerWrite = 'SchedulerWrite',
  SchedulerDump = 'SchedulerDump',
  SchedulerDumpViewer = 'SchedulerDumpViewer',
  SchedulerLoginUsers = 'SchedulerLoginUsers',
  SynchronizationPackages = 'SynchronizationPackages',
  Tasks = 'Tasks',
  TasksBulk = 'TasksBulk',
  TenantsWrite = 'TenantsWrite',
  OrchestrationWebhooks = 'OrchestrationWebhooks',
  UiPathWebhooks = 'UiPathWebhooks',
  Monitoring = 'Monitoring',
  Orchestration = 'Orchestration',
  ProcessOwner = 'ProcessOwner',
  AutomationTeam = 'AutomationTeam',
  OrganizationAdministrator = 'OrganizationAdministrator',
  AllDomains = 'AllDomains',
  SystemAdmin = 'SystemAdmin'
}
export enum ClientPermission {
  Monitoring = 'Monitoring',
  Orchestration = 'Orchestration',
  AuditLog = 'AuditLog',
  Analytics = 'Analytics',
  IncidentDetection = 'IncidentDetection',
  RuntimeAnalysis = 'RuntimeAnalysis',
  FastAnomalyDetection = 'FastAnomalyDetection',
  Reporting = 'Reporting',
  ProcessReporting = 'ProcessReporting',
  Benchmarking = 'Benchmarking',
  OrganizationSettings = 'OrganizationSettings',
  GeneralSettings = 'GeneralSettings',
  TenantsSettings = 'TenantsSettings',
  ProcessesSettings = 'ProcessesSettings',
  ResourcesSettings = 'ResourcesSettings',
  QueuesSettings = 'QueuesSettings',
  UsersSettings = 'UsersSettings',
  NotificationsSettings = 'NotificationsSettings',
  ApiCredentialsSettings = 'ApiCredentialsSettings',
  AiProvidersSettings = 'AiProvidersSettings',
  AnomaliesSettings = 'AnomaliesSettings',
  ExternalServicesSettings = 'ExternalServicesSettings',
  ConditionStates = 'ConditionStates',
  PendingSessions = 'PendingSessions',
  OrchestrationDebugging = 'OrchestrationDebugging',
  ReportingSettings = 'ReportingSettings',
  BusinessProcessesSettings = 'BusinessProcessesSettings',
  SavingsSettings = 'SavingsSettings',
  DomainsSettings = 'DomainsSettings',
  BillingGroupsSettings = 'BillingGroupsSettings',
  BenchmarkingSettings = 'BenchmarkingSettings',
  ImportExportSettings = 'ImportExportSettings',
  AiAgent = 'AiAgent',
  AnalyticsSettings = 'AnalyticsSettings',
  OrchestrationSettings = 'OrchestrationSettings',
  MetricAlerts = 'MetricAlerts',
  ProcessOwner = 'ProcessOwner',
  AutomationTeam = 'AutomationTeam',
  OrganizationAdministrator = 'OrganizationAdministrator',
  AllDomains = 'AllDomains',
  SystemAdmin = 'SystemAdmin'
}
export enum OrganizationPermission {
  AiAgent = 'AiAgent',
  Analytics = 'Analytics',
  AnalyticsSettings = 'AnalyticsSettings',
  Benchmarking = 'Benchmarking',
  BenchmarkingSettings = 'BenchmarkingSettings',
  FastAnomalyDetection = 'FastAnomalyDetection',
  IncidentDetection = 'IncidentDetection',
  MetricAlerts = 'MetricAlerts',
  Monitoring = 'Monitoring',
  Orchestration = 'Orchestration',
  OrchestrationSettings = 'OrchestrationSettings',
  Reporting = 'Reporting',
  ReportingSettings = 'ReportingSettings',
  RuntimeAnalysis = 'RuntimeAnalysis',
  Simulator = 'Simulator',
  SimulatorSettings = 'SimulatorSettings',
  ExecutiveOverview = 'ExecutiveOverview'
}
export enum AuditLogPropertyType {
  String = 'String',
  Number = 'Number',
  Boolean = 'Boolean',
  Time = 'Time',
  TimeSpan = 'TimeSpan',
  DateTime = 'DateTime',
  ProcessId = 'ProcessId',
  LoginUserId = 'LoginUserId',
  ResourceGroupId = 'ResourceGroupId',
  TaskConfiguration = 'TaskConfiguration',
  RecoveryConfiguration = 'RecoveryConfiguration',
  CalendarEvent = 'CalendarEvent',
  Json = 'Json'
}
export enum BenchmarkMetricType {
  DeliveredFte = 'DeliveredFte',
  SavedFtePerLicense = 'SavedFtePerLicense',
  ManualVsBotProcessingTimeRatio = 'ManualVsBotProcessingTimeRatio',
  ProcessesVsLicensesRatio = 'ProcessesVsLicensesRatio',
  RoiOfRpa = 'RoiOfRpa',
  CostOfSavingOneFte = 'CostOfSavingOneFte',
  FteEfficiency = 'FteEfficiency',
  TotalCostPerLicense = 'TotalCostPerLicense',
  RpaTeamEfficiency = 'RpaTeamEfficiency',
  DevelopmentEfficiency = 'DevelopmentEfficiency',
  OperationEfficiencyLicenses = 'OperationEfficiencyLicenses',
  OperationEfficiencyProcesses = 'OperationEfficiencyProcesses',
  AvgDevTimeOfSavingOneFte = 'AvgDevTimeOfSavingOneFte',
  AvgDevSpeed = 'AvgDevSpeed'
}
export enum DayOfWeek {
  Sunday = 'Sunday',
  Monday = 'Monday',
  Tuesday = 'Tuesday',
  Wednesday = 'Wednesday',
  Thursday = 'Thursday',
  Friday = 'Friday',
  Saturday = 'Saturday'
}
export enum Direction {
  Above = 'Above',
  Below = 'Below'
}
export enum IncidentPartType {
  BarChart = 'BarChart',
  Impact = 'Impact',
  MetricTimeSeries = 'MetricTimeSeries',
  MetricBreakdown = 'MetricBreakdown',
  MetricPerOwners = 'MetricPerOwners',
  MetricScatterPlot = 'MetricScatterPlot',
  MostIncreasingExceptions = 'MostIncreasingExceptions',
  Text = 'Text',
  TextList = 'TextList',
  TimeSeries = 'TimeSeries',
  TopExceptions = 'TopExceptions',
  TopExceptionsTrend = 'TopExceptionsTrend',
  UtilizationHeatmap = 'UtilizationHeatmap'
}
export enum MetricBreakdownType {
  PerResource = 'PerResource',
  PerWeekDay = 'PerWeekDay',
  TimeOfDay = 'TimeOfDay'
}
export enum TopExceptionsTrendType {
  CountOverDays = 'CountOverDays',
  RateOverDayHours = 'RateOverDayHours'
}
export enum EmailSendResult {
  Succeeded = 'Succeeded',
  Failed = 'Failed',
  ServerNotConfigured = 'ServerNotConfigured'
}
export enum EvaluationResultStatus {
  Pass = 'Pass',
  Fail = 'Fail'
}
export enum ExceptionSortBy {
  Count = 'Count',
  Cost = 'Cost'
}
export enum ProcessScheduleState {
  StartedSuccessfully = 'StartedSuccessfully',
  LoginStartedSuccessfully = 'LoginStartedSuccessfully',
  FailingToStart = 'FailingToStart',
  FailedToStart = 'FailedToStart'
}
export enum ResourceSortBy {
  Label = 'Label',
  ProcessLabel = 'ProcessLabel',
  LastActive = 'LastActive',
  Status = 'Status',
  IsEnabled = 'IsEnabled',
  IsRestartAllowed = 'IsRestartAllowed',
  IsAutoShutdownEnabled = 'IsAutoShutdownEnabled',
  LoginType = 'LoginType',
  Visibility = 'Visibility',
  CurrentLoginName = 'CurrentLoginName'
}
export enum FailReason {
  NoFreeLicenses = 'NoFreeLicenses',
  NoFreeResources = 'NoFreeResources',
  NoFreeLoginUsers = 'NoFreeLoginUsers',
  EmptyResourceGroup = 'EmptyResourceGroup',
  EmptyLoginUserGroup = 'EmptyLoginUserGroup',
  LocksAreUsed = 'LocksAreUsed',
  ExternalSystemsAreUsed = 'ExternalSystemsAreUsed',
  ConditionEvaluationError = 'ConditionEvaluationError',
  ConditionReasonNotToStart = 'ConditionReasonNotToStart',
  UnexpectedError = 'UnexpectedError',
  Timeout = 'Timeout'
}
export enum RequestStopReasonType {
  OtherProcessHasHigherPriority = 'OtherProcessHasHigherPriority',
  OtherProcessHasReservation = 'OtherProcessHasReservation',
  ShouldStopAt = 'ShouldStopAt',
  EndOfWindow = 'EndOfWindow',
  ResourceIsNotEnabled = 'ResourceIsNotEnabled',
  ResourceIsDeleted = 'ResourceIsDeleted',
  ResourceIsQuarantined = 'ResourceIsQuarantined',
  ResourceHasMaintenanceWindow = 'ResourceHasMaintenanceWindow',
  ResourceWillHaveMaintenanceWindow = 'ResourceWillHaveMaintenanceWindow',
  ProcessIsQuarantined = 'ProcessIsQuarantined',
  ProcessHasMaintenanceWindow = 'ProcessHasMaintenanceWindow',
  ExternalSystemIsQuarantined = 'ExternalSystemIsQuarantined',
  ExternalSystemHasMaintenanceWindow = 'ExternalSystemHasMaintenanceWindow',
  ExternalSystemWillHaveMaintenanceWindow = 'ExternalSystemWillHaveMaintenanceWindow',
  ExternalSystemIsNotAvailable = 'ExternalSystemIsNotAvailable'
}
export enum ResourceUnavailabilityReason {
  Unknown = 'Unknown',
  NotFoundInRpaSystem = 'NotFoundInRpaSystem',
  Offline = 'Offline',
  NotResponding = 'NotResponding',
  SameResourceConditionNotMet = 'SameResourceConditionNotMet',
  Disabled = 'Disabled',
  Deleted = 'Deleted',
  Reserved = 'Reserved',
  Working = 'Working',
  LoggedOut = 'LoggedOut',
  Private = 'Private',
  Available = 'Available',
  Quarantined = 'Quarantined',
  MaintenanceWindow = 'MaintenanceWindow'
}
export enum SessionFinishedStatus {
  Success = 'Success',
  BusinessException = 'BusinessException',
  SystemException = 'SystemException',
  UnexpectedInterruption = 'UnexpectedInterruption',
  Exception = 'Exception',
  Any = 'Any'
}
export enum FileSystemEvent {
  Created = 'Created',
  Changed = 'Changed',
  Deleted = 'Deleted'
}
export enum IntervalType {
  Month = 'Month',
  Year = 'Year'
}
export enum Marking {
  Success = 'Success',
  Exception = 'Exception'
}
export enum MasterProcessStatus {
  Created = 'Created',
  Uploaded = 'Uploaded',
  Split = 'Split',
  Transformed = 'Transformed',
  Successful = 'Successful',
  Failed = 'Failed',
  Deleted = 'Deleted',
  Canceled = 'Canceled'
}
export enum LoginType {
  Password = 'Password',
  Microsoft = 'Microsoft',
  ApiKey = 'ApiKey',
  AdToken = 'AdToken'
}
export enum ManagementMetricsAggregationType {
  Day = 'Day',
  Week = 'Week',
  Month = 'Month'
}
export enum MetricAggregationFunc {
  Sum = 'Sum',
  Average = 'Average',
  Median = 'Median',
  Maximum = 'Maximum'
}
export enum MetricSourceType {
  Queue = 'Queue',
  Process = 'Process',
  ProcessGroup = 'ProcessGroup'
}
export enum MetricValueType {
  Number = 'Number',
  Decimal = 'Decimal',
  Percentage = 'Percentage',
  Duration = 'Duration'
}
export enum PauseOrchestrationType {
  All = 'All',
  Tag = 'Tag',
  Processes = 'Processes',
  Resources = 'Resources',
  ExternalSystems = 'ExternalSystems'
}
export enum RecoveryConfigurationAction {
  RestartResource = 'RestartResource',
  SetProcessIsQuarantined = 'SetProcessIsQuarantined',
  SetResourceIsQuarantined = 'SetResourceIsQuarantined',
  SetLoginUserIsQuarantined = 'SetLoginUserIsQuarantined',
  SetExternalSystemIsQuarantined = 'SetExternalSystemIsQuarantined',
  RunSession = 'RunSession'
}
export enum RecoveryConfigurationCondition {
  SessionException = 'SessionException',
  ItemException = 'ItemException',
  LongSession = 'LongSession',
  LongItem = 'LongItem',
  FrozenSession = 'FrozenSession'
}
export enum ResourceLoginType {
  NoLogin = 'NoLogin',
  ResourceLogin = 'ResourceLogin',
  ProcessLogin = 'ProcessLogin',
  ProcessLoginWithoutLogout = 'ProcessLoginWithoutLogout'
}
export enum ResourceTaskConfigurationAction {
  LoginResource = 'LoginResource',
  LogoutResource = 'LogoutResource'
}
export enum SchedulerTaskConfigurationCondition {
  Regularly = 'Regularly',
  Once = 'Once',
  QueueNotEmpty = 'QueueNotEmpty',
  ProcessFinished = 'ProcessFinished',
  FileSystem = 'FileSystem',
  Webhook = 'Webhook',
  Code = 'Code',
  RunNow = 'RunNow',
  Email = 'Email'
}
export enum SchedulerTaskConfigurationDateCondition {
  EveryDay = 'EveryDay',
  WeekDays = 'WeekDays',
  Weekends = 'Weekends',
  DaysOfWeek = 'DaysOfWeek',
  DaysOf = 'DaysOf',
  DayOfWeekOfMonth = 'DayOfWeekOfMonth',
  Holidays = 'Holidays',
  NonWorkingDays = 'NonWorkingDays',
  CalendarEventDay = 'CalendarEventDay'
}
export enum SchedulerTaskConfigurationDaysOfPeriod {
  Month = 'Month',
  Week = 'Week'
}
export enum SchedulerTaskConfigurationFileSystemCondition {
  File = 'File',
  Directory = 'Directory',
  SharePoint = 'SharePoint',
  SharePointList = 'SharePointList'
}
export enum SchedulerTaskConfigurationTimeCondition {
  ExactTimes = 'ExactTimes',
  ExactTimesObsolete = 'ExactTimesObsolete',
  TimesObsolete = 'TimesObsolete',
  TimeWindows = 'TimeWindows'
}
export enum TaskUserPriority {
  Low = 'Low',
  Medium = 'Medium',
  High = 'High',
  RunNow = 'RunNow'
}
export enum SchedulerActionType {
  LoginResource = 'LoginResource',
  LogoutResource = 'LogoutResource',
  Nothing = 'Nothing',
  RestartResources = 'RestartResources',
  RunShell = 'RunShell',
  SetExternalSystemIsQuarantined = 'SetExternalSystemIsQuarantined',
  SetLoginUsersIsQuarantined = 'SetLoginUsersIsQuarantined',
  SetProcessIsQuarantined = 'SetProcessIsQuarantined',
  SetResourcesIsQuarantined = 'SetResourcesIsQuarantined',
  SetTasksIsActive = 'SetTasksIsActive'
}
export enum SchedulerConditionType {
  CalendarEventDay = 'CalendarEventDay',
  CSharp = 'CSharp',
  Date = 'Date',
  DateTime = 'DateTime',
  DayOfWeekOfMonth = 'DayOfWeekOfMonth',
  DaysOfMonth = 'DaysOfMonth',
  DaysOfWeek2 = 'DaysOfWeek2',
  DaysOfWeek = 'DaysOfWeek',
  Directory = 'Directory',
  Email = 'Email',
  EmptyQueue = 'EmptyQueue',
  Exception = 'Exception',
  ExternalSystems = 'ExternalSystems',
  File = 'File',
  FrozenSession = 'FrozenSession',
  IsHoliday = 'IsHoliday',
  IsNotCalendarEventDay = 'IsNotCalendarEventDay',
  IsNotHoliday = 'IsNotHoliday',
  IsNotWorkingDay = 'IsNotWorkingDay',
  IsWeekDay = 'IsWeekDay',
  IsWeekend = 'IsWeekend',
  LongItem = 'LongItem',
  LongSession = 'LongSession',
  LongSessionWithItems = 'LongSessionWithItems',
  Months = 'Months',
  NoItemsLoadedThisMonth = 'NoItemsLoadedThisMonth',
  NoItemsLoadedToday = 'NoItemsLoadedToday',
  OnceADay = 'OnceADay',
  OnceAPeriod = 'OnceAPeriod',
  OnceAWindow = 'OnceAWindow',
  ProcessFinished = 'ProcessFinished',
  Queue = 'Queue',
  RunNow = 'RunNow',
  SharePoint = 'SharePoint',
  SharePointList = 'SharePointList',
  StartInTimeWindow = 'StartInTimeWindow',
  TaskFinished = 'TaskFinished',
  Time = 'Time',
  TimeWindow = 'TimeWindow',
  Webhook = 'Webhook'
}
